// Application Configuration
// Use environment variables in production

export const CONFIG = {
    // API Configuration
    API_BASE: window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
        ? '/api'
        : 'https://inflation-api.tastelessmediabuyer.workers.dev',

    // AdSense Configuration (replace with actual values)
    AD_CLIENT: 'ca-pub-YOUR_AD_CLIENT_ID',

    // UI Timing Constants
    TOAST_DURATION: 3000,
    TOAST_FADE_DURATION: 300,
    SEARCH_DEBOUNCE_MS: 300,
    AUTO_REFRESH_INTERVAL: 15 * 60 * 1000, // 15 minutes

    // UI Feedback
    ADD_BUTTON_FEEDBACK_DURATION: 1000,

    // API Resilience
    API_RETRY_ATTEMPTS: 3,
    API_RETRY_DELAY_MS: 1000,
    API_TIMEOUT_MS: 10000,
    CACHE_TTL_MS: 5 * 60 * 1000, // 5 minutes
} as const;
